import type { SubscriptionInfo } from '@shared/types/api'
import apiClient from './client'

export const subscriptionApi = {
  /**
   * Get subscription information (limits and usage)
   */
  getInfo: async (userId: string): Promise<SubscriptionInfo> => {
    const response = await apiClient.get<SubscriptionInfo>(`/users/${userId}/subscription`)
    return response.data
  },
}
